import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text, Image } from '@chakra-ui/react';
import { Section, Accordion } from '@whitbread-eos/atoms';
import { formatDate, useCustomLocale, getPIBrandText, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { TRIP_ADVISOR_RATING_IMAGE_URL_PART1, TRIP_ADVISOR_RATING_IMAGE_URL_PART2 } from '../../../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BottomReviewSection(_ref) {
  var _tripAdvisorData$subR;
  var tripAdvisorData = _ref.tripAdvisorData,
    brand = _ref.brand,
    title = _ref.title;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var getTypographyProps = useSemanticTypography();
  var seeReviewsLabel = t('tripadvisor.show.reviews');
  var _useState = useState(seeReviewsLabel),
    _useState2 = _slicedToArray(_useState, 2),
    accordionTitle = _useState2[0],
    setAccordionTitle = _useState2[1];
  var onRedirectToTripAdvisor = url => {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };
  if (!tripAdvisorData || !Object.keys(tripAdvisorData).length) {
    return null;
  }
  var renderUserReviewSection = reviews => {
    return reviews === null || reviews === void 0 ? void 0 : reviews.map(reviewData => {
      var _reviewData$rating, _reviewData$rating2, _reviewData$published, _reviewData$user, _reviewData$user2;
      return _jsxs(Box, {
        marginY: 3,
        children: [_jsx(Box, {
          children: _jsx("meta", {
            content: "Trip Advisor"
          })
        }), _jsxs(Flex, {
          alignItems: 'center',
          children: [_jsx("span", {
            children: _jsx(Image, {
              src: "".concat(TRIP_ADVISOR_RATING_IMAGE_URL_PART1).concat((Math.round(((_reviewData$rating = reviewData === null || reviewData === void 0 ? void 0 : reviewData.rating) !== null && _reviewData$rating !== void 0 ? _reviewData$rating : 0) * 2) / 2).toFixed(1)).concat(TRIP_ADVISOR_RATING_IMAGE_URL_PART2),
              alt: "".concat(t('booking.hotel.summary.tripAdvisorRating'), " ").concat((Math.round(((_reviewData$rating2 = reviewData === null || reviewData === void 0 ? void 0 : reviewData.rating) !== null && _reviewData$rating2 !== void 0 ? _reviewData$rating2 : 0) * 2) / 2).toFixed(1))
            })
          }), _jsx(Text, {
            marginLeft: '1',
            children: formatDate(new Date((_reviewData$published = reviewData === null || reviewData === void 0 ? void 0 : reviewData.publishedDate) !== null && _reviewData$published !== void 0 ? _reviewData$published : '').toDateString(), 'dd MMM yyyy', language)
          })]
        }), _jsxs(Box, {
          children: [_jsx(Text, {
            fontWeight: 'semibold',
            marginY: 1,
            children: reviewData === null || reviewData === void 0 || (_reviewData$user = reviewData.user) === null || _reviewData$user === void 0 ? void 0 : _reviewData$user.username
          }), _jsx(Text, {
            marginY: 1,
            children: reviewData === null || reviewData === void 0 || (_reviewData$user2 = reviewData.user) === null || _reviewData$user2 === void 0 ? void 0 : _reviewData$user2.location
          }), _jsxs(Flex, {
            marginY: 1,
            children: [_jsx(Text, {
              fontWeight: 'bold',
              children: "".concat(t('hoteldetails.tripadvisorreviewstriptype'), ": ")
            }), _jsx(Text, {
              marginLeft: 1,
              children: reviewData === null || reviewData === void 0 ? void 0 : reviewData.tripType
            })]
          })]
        }), _jsx(Box, {
          fontStyle: 'italic',
          marginY: 1,
          children: "\"".concat(reviewData === null || reviewData === void 0 ? void 0 : reviewData.title, "\"")
        }), _jsx(Box, {
          marginY: 1,
          children: reviewData === null || reviewData === void 0 ? void 0 : reviewData.text
        })]
      }, "reviews-".concat(reviewData === null || reviewData === void 0 ? void 0 : reviewData.publishedDate));
    });
  };
  return _jsx(Section, {
    dataTestId: "tripadvisor-bottom-review-section-hdp",
    children: _jsxs(Box, _objectSpread(_objectSpread({}, containerStyles), {}, {
      "data-testid": "tripadvisor-user-review-section",
      id: "tripadvisor-user-review-section",
      children: [_jsxs(Text, _objectSpread(_objectSpread(_objectSpread({}, headingLayoutStyles), getTypographyProps(headingLegacyTypography, headingSemanticTypography)), {}, {
        as: "h3",
        children: [t('hoteldetails.tripadvisorreviews.title'), getPIBrandText(t, brand), title]
      })), _jsxs(Flex, _objectSpread(_objectSpread({}, reviewContainerFlexStyles), {}, {
        children: [_jsx(Accordion, {
          accordionOverwriteStyles: _objectSpread({}, accordionOverwriteStyles),
          bgColor: "lightGrey5",
          accordionItems: [{
            title: accordionTitle,
            onToggleSection: () => setAccordionTitle(accordionTitle === seeReviewsLabel ? t('tripadvisor.hide.reviews') : seeReviewsLabel),
            content: _jsxs(Box, {
              children: [renderUserReviewSection(tripAdvisorData === null || tripAdvisorData === void 0 ? void 0 : tripAdvisorData.reviews), _jsxs(Flex, {
                marginY: 4,
                alignItems: 'center',
                children: [_jsx(Text, _objectSpread(_objectSpread({}, redirectLinkStyles), {}, {
                  "data-testid": "tripadvisor-see-reviews-link",
                  onClick: () => {
                    var _tripAdvisorData$webU;
                    return onRedirectToTripAdvisor((_tripAdvisorData$webU = tripAdvisorData === null || tripAdvisorData === void 0 ? void 0 : tripAdvisorData.webUrl) !== null && _tripAdvisorData$webU !== void 0 ? _tripAdvisorData$webU : '');
                  },
                  children: t('tripadvisor.see.reviews')
                })), _jsx(Text, {
                  children: t('tripadvisor.see.reviews.onTripadvisor')
                })]
              })]
            })
          }]
        }), _jsxs(Box, {
          children: [_jsx(Text, _objectSpread(_objectSpread({}, getTypographyProps(tripAdvisorBroughtByLegacyTypography, tripAdvisorBroughtBySemanticTypography)), {}, {
            children: t('hoteldetails.tripadvisorreviewsbroughtby')
          })), _jsx(Image, _objectSpread(_objectSpread({}, logoStyle), {}, {
            src: t('tripadvisor.primarylogo')
          })), _jsx(Box, {
            "data-testid": "subrating-section",
            children: tripAdvisorData === null || tripAdvisorData === void 0 || (_tripAdvisorData$subR = tripAdvisorData.subRatings) === null || _tripAdvisorData$subR === void 0 ? void 0 : _tripAdvisorData$subR.map(subRatingData => _jsxs(Flex, {
              children: [_jsx(Box, {
                minWidth: '60%',
                maxWidth: '60%',
                children: _jsx(Text, _objectSpread(_objectSpread({}, getTypographyProps({}, subratingLabelSemanticTypography)), {}, {
                  children: subRatingData === null || subRatingData === void 0 ? void 0 : subRatingData.localisedName
                }))
              }), _jsx(Image, {
                src: subRatingData === null || subRatingData === void 0 ? void 0 : subRatingData.ratingImageUrl,
                marginRight: 2
              })]
            }, "sunbrating-".concat(subRatingData === null || subRatingData === void 0 ? void 0 : subRatingData.localisedName)))
          }), _jsx(Box, {
            children: _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, writeReviewLinkLayoutStyles), getTypographyProps(writeReviewLinkLegacyTypography, writeReviewLinkSemanticTypography)), {}, {
              marginTop: 4,
              "data-testid": "tripadvisor-write-review-link",
              onClick: () => {
                var _tripAdvisorData$writ;
                return onRedirectToTripAdvisor((_tripAdvisorData$writ = tripAdvisorData === null || tripAdvisorData === void 0 ? void 0 : tripAdvisorData.writeReview) !== null && _tripAdvisorData$writ !== void 0 ? _tripAdvisorData$writ : '');
              },
              children: t('tripadvisor.write.review')
            }))
          })]
        })]
      }))]
    }))
  });
}
var headingLayoutStyles = {
  mb: 'md'
};
var headingLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: {
    base: 'xl',
    sm: '2xl'
  },
  lineHeight: {
    base: '3',
    sm: '4'
  }
};
var headingSemanticTypography = {
  textStyle: 'heading-m'
};
var tripAdvisorBroughtByLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'sm'
};
var tripAdvisorBroughtBySemanticTypography = {
  textStyle: 'body-s-emphasis'
};
var subratingLabelSemanticTypography = {
  textStyle: 'body-m-regular'
};
var writeReviewLinkLayoutStyles = {
  display: 'inline-block',
  marginRight: '1',
  color: 'btnSecondaryEnabled',
  textDecoration: 'underline',
  _hover: {
    cursor: 'pointer'
  }
};
var writeReviewLinkLegacyTypography = {
  fontSize: 'md',
  lineHeight: '2'
};
var writeReviewLinkSemanticTypography = {
  textStyle: 'link-m-regular'
};
var containerStyles = {
  mt: {
    base: 'lg',
    sm: '3xl'
  },
  mb: {
    base: 'lg',
    sm: '2xl'
  }
};
var reviewContainerFlexStyles = {
  flexDirection: {
    base: 'column-reverse',
    sm: 'row'
  },
  justifyContent: 'space-between',
  gap: '2.5rem',
  marginRight: '2'
};
var redirectLinkStyles = {
  display: 'inline-block',
  fontSize: 'md',
  lineHeight: '2',
  marginRight: '1',
  color: 'btnSecondaryEnabled',
  textDecoration: 'underline',
  _hover: {
    cursor: 'pointer'
  }
};
var logoStyle = {
  height: '38px',
  marginY: '3',
  objectFit: 'cover'
};
var accordionOverwriteStyles = {
  container: {
    w: {
      base: 'full',
      sm: '50%',
      md: '70%'
    }
  },
  button: {
    borderWidth: 0,
    borderBottom: 0,
    borderTop: 0,
    backgroundColor: 'lightGrey5',
    _hover: {
      backgroundColor: 'lightGrey5'
    },
    _expanded: {
      borderBottomRadius: 'var(--chakra-radii-none)'
    },
    borderRadius: 'var(--chakra-radii-xl)',
    px: 'var(--chakra-space-lg)'
  },
  item: {
    border: 0,
    w: {
      base: 'full',
      lg: '53.125rem'
    }
  },
  text: {
    color: 'btnSecondaryEnabled',
    fontSize: 'lg',
    fontWeight: 'semibold'
  },
  panel: {
    padding: 'var(--chakra-space-sm) var(--chakra-space-lg)',
    borderBottomRadius: 'var(--chakra-radii-xl)'
  }
};